import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, getInlineLoader } from "../Helpers";
import {
	STR_AMOUNT_2,
	STR_AVAILABLE_HOTELS,
	STR_BACK,
	STR_CASH,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_FLOAT,
	STR_INVALID_SERVICE_PROVIDER,
	STR_MENU_HOTELS,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_RECENT_REQUESTS,
	STR_REQUEST_AMOUNT_LIMIT,
	STR_REQUEST_FLOAT,
	STR_REQUEST_FLOAT_CASH,
	STR_SELECT,
	STR_SELECT_2,
	STR_SELECT_REQUEST_TYPE,
	STR_SERVICE_PROVIDER,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCheckCircle, MdContactPage, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import login_bg from '../assets/login_bg.jpg';
import HomeMenu from "./HomeMenu";
import WelcomeSlider from '../ones/WelcomeSlider';
import EditAgentProfile from "./EditAgentProfile";
import OpSuccessWidget from "../ones/OpSuccessWidget";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [requestType, setRequestType] = useState('float');
	const [tillType, setTillType] = useState('');
	const [amount, setAmount] = useState(0);
	const [offerExchange, setOfferExchange] = useState('no');
	const [offerExchangeFrom, setOfferExchangeFrom] = useState('');
	const [opSuccessful, setOpSuccessful] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	async function submit() {
		if(requestType && requestType.trim().length > 0) {
			if(tillType && tillType.trim().length > 0) {
				if(!isNaN(amount) && Number(amount) >= 10000) {
					setLoading(true);
					await callApi(
						'create-agent-request',
						{
							amount,
							requestType,
							tillType,
							offerExchange,
							offerExchangeFrom,
						}
					).then((response) => {
						if(response.status === 1) {
							setOpSuccessful(true);
						} else {
							appContext.tellError(response.msg)
						}
					})
					setLoading(false);
				} else {
					appContext.tellError(STR_REQUEST_AMOUNT_LIMIT[appContext.language]);
				}
			} else {
				appContext.tellError(STR_INVALID_SERVICE_PROVIDER[appContext.language]);
			}
		} else {
			appContext.tellError(STR_SELECT_REQUEST_TYPE[appContext.language]);
		}
	}


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])


	if (ready) {
		if(appContext.isAgentProfileComplete) {
			return (
				<div
					style={{
						width: "100%",
						height: "100%",
						overflow: "scroll",
						paddingBottom: "calc(var(--topBarHeight) + 40px)",
					}}
					className="mNoScrollBar"
				>
					<div className="container">
	
						<div className="row">
	
							<div className="col-md-12">
								<h6
									className="mSectionTitle"
								>
									{STR_REQUEST_FLOAT_CASH[appContext.language]}
								</h6>
							</div>

							{
								(opSuccessful) ?
								<div 
									className="col-md-12"
								>
									<OpSuccessWidget/>
								</div>
								:
								<div 
									className="col-md-12"
								>
									<div className="mt-4 mb-4">
										<label className="form-label">{STR_SELECT_2[appContext.language]}</label>
										<div className="row">
											

											<div className="col-6 mb-1">
												<button
													className={(requestType === 'float') ? "btn btn-secondary" : "btn btn-outline-secondary"}
													style={{
														width: "100%",
														paddingTop: "20px",
														paddingBottom: "20px",
														fontSize: "28px",
														fontFamily: "FontLight",
													}}
													onClick={() => setRequestType('float')}
												>
													{STR_FLOAT[appContext.language]}
												</button>
											</div>

											<div className="col-6 mb-1">
												<button
													className={(requestType === 'cash') ? "btn btn-secondary" : "btn btn-outline-secondary"}
													style={{
														width: "100%",
														paddingTop: "20px",
														paddingBottom: "20px",
														fontSize: "28px",
														fontFamily: "FontLight",
													}}
													onClick={() => setRequestType('cash')}
												>
													{STR_CASH[appContext.language]}
												</button>
											</div>

										</div>
									</div>

									<div className="mt-4 mb-4">
										<label className="form-label">{STR_SERVICE_PROVIDER[appContext.language]}</label>
										<div className="row">
											
											{
												JSON.parse(appContext.systemParams.supportedTillTypes).map((item, i) => {
													return (
														<div className="col-4 mb-2" key={i}>
															<button
																className={(tillType === item.id) ? "btn btn-secondary" : "btn btn-outline-secondary"}
																style={{
																	width: "100%",
																	height: "70px",
																	paddingTop: "10px",
																	paddingBottom: "10px",
																	fontSize: "14px",
																	fontFamily: "FontBold",
																}}
																onClick={() => setTillType(item.id)}
															>
																{item.name}
															</button>
														</div>
													)
												})
											}

											
										</div>
									</div>

									<div className="mt-4 mb-4">
										<label className="form-label">{STR_AMOUNT_2[appContext.language]}</label>
										<input
											className="form-control font-bold"
											value={amount}
											onChange={(e) => setAmount(e.target.value)}
											style={{
												fontSize: "36px"
											}}
											placeholder="eg 10000"
										/>
										<div className="form-text">
											{STR_REQUEST_AMOUNT_LIMIT[appContext.language]}
										</div>
									</div>

									<div className="mt-4 mb-4">
										<button
											className="btn btn-block btn-primary btn-padded btn-rounded"
											onClick={submit}
										>
											{STR_SUBMIT[appContext.language]}
										</button>
									</div>

								</div>
							}
	
						</div>
	
						
	
					</div>
	
	
				</div>
			)
		} else {
			return <EditAgentProfile/>
		}
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}